/**
 * "Done" on a Today's plan item — the same two writes as Home.handleAcknowledge: the item key joins
 * the per-user ack set in localStorage (so Home hides it at once), then POST /api/todays-plan/ack
 * persists it. Used by the Tasks page, which has no Home state to call into.
 */
import { addPlanItemToAckSet, planItemKey } from '@/lib/todaysPlanUtils';

const API_BASE_URL = 'https://api.neogtm.com';
const ACK_KEY_PREFIX = 'tp-ack-v1:';

export function readAckSet(userId) {
  try {
    const arr = JSON.parse(localStorage.getItem(ACK_KEY_PREFIX + (userId || 'anon')) || '[]');
    return new Set(Array.isArray(arr) ? arr : []);
  } catch {
    return new Set();
  }
}

export async function acknowledgePlanItem({ tenantId, userId, item }) {
  try {
    const next = addPlanItemToAckSet(readAckSet(userId), item);
    localStorage.setItem(ACK_KEY_PREFIX + (userId || 'anon'), JSON.stringify([...next]));
  } catch {
    /* storage unavailable */
  }
  const res = await fetch(`${API_BASE_URL}/api/todays-plan/ack?user_id=${encodeURIComponent(userId)}&tenant_id=${encodeURIComponent(tenantId)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'x-user-id': userId || '', 'x-tenant-id': tenantId },
    credentials: 'include',
    body: JSON.stringify({
      itemKey: planItemKey(item),
      personaId: item.personaId || item.person_id || item.persona_id,
      personaName: item.personaName,
      accountName: item.accountName,
      tenant_id: tenantId,
      user_id: userId,
    }),
  });
  if (!res.ok && res.status !== 404) throw new Error(`Could not save (${res.status})`);
}
